module.exports = __webpack_public_path__ + "static/img/commodity_sing05.3afa791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing05.png
// module id = r4ML
// module chunks = 174